import { render, staticRenderFns } from "./scale-screen.vue?vue&type=template&id=da9f1cae&scoped=true"
import script from "./scale-screen.vue?vue&type=script&lang=js"
export * from "./scale-screen.vue?vue&type=script&lang=js"
import style0 from "./scale-screen.vue?vue&type=style&index=0&id=da9f1cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9f1cae",
  null
  
)

export default component.exports